import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { createGlobalStyle } from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

function BcInfos({ indicatorDescription }) {
  const collectionPoolName =
    window.sessionStorage.getItem('collectionPoolName');
  const cpValue = indicatorDescription?.cp_tp[0]?.value;
  const tpValue = indicatorDescription?.cp_tp[1]?.value;

  return (
    <Container className='bc_infos'>
      <Styles />
      <Word className='title' value='Pour l’année « N-1 » :' />
      <ul className='circle-list'>
        <li>
          % de remontée des données de télégestion du
          <span> {collectionPoolName}</span> :{' '}
          <span>{cpValue ? `${cpValue}%` : 'NR'}</span>
        </li>
        <li>
          % de remontée des données de télégestion pour le TP du
          <span> {collectionPoolName}</span>:{' '}
          <span>{tpValue ? `${tpValue}%` : 'NR'}</span>
        </li>
        <li>
          % de remontée des données de télégestion du :
          {indicatorDescription?.do.length > 0 ? (
            <ul className='square-list'>
              {indicatorDescription?.do.map((item) => (
                <li key={uuidv4()}>
                  {item.mainInstallName} :{' '}
                  <span>{item?.value != null ? `${item.value}%` : 'NR'}</span>
                </li>
              ))}
            </ul>
          ) : (
            ' NR'
          )}
        </li>
      </ul>
    </Container>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
.bc_infos{
    .title,span {
        font-weight: bold;
    }
    .circle-list{
        list-style-type: circle;
    }
    .square-list{
        list-style-type: square;
    }
    .criticity_infos{
       color: #008BD2;
       font-size: 13px;
       line-height: 18px;
       width: 279px;
       font-weight: bold;
       margin-top: 50px
    }
}
.contentContainer{
      .criticalities-title{
      text-align: center;
      margin-bottom: 15px;
    }
    .criticalitiesContainer{
      height: 600px;
      overflow-x: auto;
      scrollbar-width: thin;
    }
    }
}`;
export default BcInfos;
